import Vue from 'vue'
import { initialState } from './state';

export const mutationTypes = {
	PAGES_LOAD: 'PAGES_LOAD',
	PAGES_CREATE: 'PAGES_CREATE',
	PAGES_UPDATE: 'PAGES_UPDATE',
	PAGES_DELETE: 'PAGES_DELETE',
	PAGES_VALIDATION_ERRORS: 'PAGES_VALIDATION_ERRORS',
	PAGES_VALIDATION_CLEAR: 'PAGES_VALIDATION_CLEAR',
	PAGES_VALIDATION_MODAL: 'PAGES_VALIDATION_MODAL',
	PAGES_FILES_LOAD: 'PAGES_FILES_LOAD',
	PAGES_FILES_CREATE: 'PAGES_FILES_CREATE',
	PAGES_FILES_UPDATE: 'PAGES_FILES_UPDATE',
	PAGES_FILES_DELETE: 'PAGES_FILES_DELETE',
	PAGES_SNIPPETS_LOAD: 'PAGES_SNIPPETS_LOAD',
	PAGES_SNIPPETS_CREATE: 'PAGES_SNIPPETS_CREATE',
	PAGES_SNIPPETS_UPDATE: 'PAGES_SNIPPETS_UPDATE',
	PAGES_SNIPPETS_DELETE: 'PAGES_SNIPPETS_DELETE',
	LOGOUT: 'LOGOUT'
};

export default {
	[mutationTypes.PAGES_LOAD](state, data) {
		state.pages = data
	},
	[mutationTypes.PAGES_CREATE](state, data) {
		state.pages.push(data)
	},
	[mutationTypes.PAGES_UPDATE](state, data) {
		const i = state.pages.findIndex(item => item.id == data.id)
		Vue.set(state.pages, i, data) 
	},
	[mutationTypes.PAGES_DELETE](state, page) {
		const i = state.pages.findIndex(item => item.id == page.id)
		state.pages.splice(i,1)
	},
	[mutationTypes.PAGES_VALIDATION_ERRORS](state, data) {		
		state.pagesValidationErrors = data
	},
	[mutationTypes.PAGES_VALIDATION_CLEAR](state) {		
		state.pagesValidationErrors = false
	},
	[mutationTypes.PAGES_VALIDATION_MODAL](state, data) {		
		state.pagesValidationModal = data
	},	
	[mutationTypes.PAGES_FILES_LOAD](state, data) {
		state.pagesFiles = data
	},
	[mutationTypes.PAGES_FILES_CREATE](state, pageFile) {
		state.pagesFiles.push(pageFile)
	},
	[mutationTypes.PAGES_FILES_UPDATE](state, pageFile) {
		const i = state.pagesFiles.findIndex(item => item.id == pageFile.id)
		Vue.set(state.pagesFiles, i, pageFile) 
	},
	[mutationTypes.PAGES_FILES_DELETE](state, pageFile) {
		const i = state.pagesFiles.findIndex(temp => temp.id == pageFile.id)
		state.pagesFiles.splice(i,1)
	},
	[mutationTypes.PAGES_SNIPPETS_LOAD](state, data) {
		state.pagesSnippets = data
	},
	[mutationTypes.PAGES_SNIPPETS_CREATE](state, data) {
		state.pagesSnippets.push(data)
	},
	[mutationTypes.PAGES_SNIPPETS_UPDATE](state, data) {
		const i = state.pagesSnippets.findIndex(item => item.id == data.id)
		Vue.set(state.pagesSnippets, i, data) 
	},
	[mutationTypes.PAGES_SNIPPETS_DELETE](state, data) {
		const i = state.pagesSnippets.findIndex(temp => temp.id == data.id)
		state.pagesSnippets.splice(i,1)
	},
	[mutationTypes.LOGOUT](state) {
		const s = initialState();
		Object.keys(initialState()).forEach(key => state[key] = s[key]);
	}
};
